/* eslint-disable @typescript-eslint/no-explicit-any */
import { Autocomplete, Box, TextField } from "@mui/material";
import { useState } from "react";

type Props = {
  name: string,
  value: any,
  onChange: any,
  options?: any,
  text?: string
  disabled?: boolean,
}

export const OtherSelect = (props: Props) => {
  const { name, value, options, text, disabled, onChange } = props
  const defaultSelectValue = value ? value.split("|")[0] : null
  const defaultTextValue = value ? value.split("|")[1] : ""
  const [selectedValue, setSelectedValue] = useState<string|null>(defaultSelectValue)
  const [textValue, setTextValue] = useState<string>(defaultTextValue)
  const [textDisabled, setTextDisabled] = useState<boolean>(defaultSelectValue !== "その他")
  const [isError, setError] = useState<boolean>(false)

  const onChangeSelect = (e: React.SyntheticEvent, value: string|null) => {
    const name = e.currentTarget.id.split('-')[0]
    setSelectedValue(value)
    value === "その他" ? setTextDisabled(false) : setTextDisabled(true)
    onChange({ name, value: value === "その他" ? `その他|${textValue}` : value })
    if (value === "その他" && textValue === "") {
      setError(true)
    }
    else {
      setError(false)
    }
  }

  const onChangeText = (e: any) => {
    const value = e.target.value
    setTextValue(value)
    onChange({ name, value: `その他|${value}` })
    if (value === "" && selectedValue === "その他") {
      setError(true)
    }
    else {
      setError(false)
    }
  }

  return (
    <Box display="contents" justifyContent="center">
      <Box>
        <Autocomplete
          id={name}
          blurOnSelect={true}
          value={selectedValue || null}
          options={options && ([...options.map((o: any) => o.label), "その他"])}
          sx={{ width: 200 }}
          renderInput={(params) => <TextField {...params} name={name} label={text} />}
          onChange={onChangeSelect}
          disabled={disabled}
        />
      </Box>
      <Box mt={2}>
        <TextField
          error={isError}
          id={name}
          name={name}
          onChange={onChangeText}
          value={textValue}
          defaultValue={defaultTextValue}
          disabled={textDisabled}
          label="その他の場合に入力"
        />
      </Box>
    </Box>

  );
};
